import { useMemo } from "react";
import {
    getTeamInfo,
    type TeamInfoReturnType,
  } from "shared/src/hooks/getTeamInfo";
import { drawTieTeams } from "./drawTieTeams";

const noFlagList = ["nba", "nfl", "mlb", "nhl", "wnba", "college"];
const teamsCollisions = ["monaco", "andorra"];
const womensRE = [/\(W\)/i, /\(?[Ww]omens?\)?$/i];

export const resolveTeam = ({ team, displayName, sport, league, country, competitionType }) => {
  let teamInfo: TeamInfoReturnType = {
      name: "",
      city: "",
      abbreviation: "",
      shortName: "",
      nickName: "",
      league: "",
      metadata: {
        colors: {
          primary: { value: "", type: "color" },
          secondary: { value: "", type: "color" },
        }
      }
    };
     
    const hasTeam = !!team;
    const hasDisplayName = !!displayName;
    const hasCountry = !!country;

    const isFlagAllowed = !noFlagList.includes(league);
    
    let _team = hasTeam ? team.trim() : "";
    
    const isWomens = (typeof _team === "string" || typeof country === "string") && womensRE.some(re => {
      // console.log({ re, _team, country, result: { team: re.test(_team), country: re.test(country) }  })
      return re.test(_team) || re.test(country)
    });
    
    // console.log(womensRE.map(re => {
      //   // console.log({ re, _team, country, result: { team: re.test(_team), country: re.test(country) }  })
      //   return re.test(_team) || re.test(country)
      // }))
      
   const sportIsRugbyType = sport && sport?.includes("rugby");  
    const limitTo = competitionType !== undefined || league 
      ? { limitTo: [competitionType !== undefined ? competitionType : league] } 
      : sportIsRugbyType 
        ? { limitTo: ["rugby", "countries"] } 
        : undefined;

    if (hasTeam && _team) {
      const resolvedCollegeTeam = getTeamInfo(`college-${_team}`, limitTo);
      const resolvedTeam = getTeamInfo(sportIsRugbyType ? `rugby-${_team}`.toLowerCase() : _team, limitTo);
      if (isFlagAllowed) {
        teamInfo = resolvedTeam || teamInfo;
      } else {
        teamInfo = resolvedCollegeTeam || resolvedTeam || teamInfo;
      }
    }

    if (hasCountry) {
      let _country = country;
      if (teamsCollisions.includes(country.toLowerCase())) _country = `countries-${country.toLowerCase().slice(0,3)}`;
      if (_country.length <= 3) {
        teamInfo = getTeamInfo(`countries-${_country}`, { limitTo: ["countries"] }) ?? teamInfo;
      } else {
        teamInfo = getTeamInfo(_country, { limitTo: ["countries"] }) ?? teamInfo;
      }
    }


    const hasFoundTeam = !!teamInfo?.name;
    const isTeamCountry = hasFoundTeam && teamInfo?.league === "countries" && isFlagAllowed;

    let _displayName = displayName;
    if (hasTeam && !hasFoundTeam && !hasDisplayName) _displayName = _team;
    if (!hasDisplayName && isTeamCountry && hasFoundTeam) _displayName = teamInfo.name;

    const isDrawTeam = drawTieTeams.includes(_team?.toLowerCase());
  return { teamInfo, isWomens, hasTeam, hasFoundTeam, hasDisplayName, hasCountry, isTeamCountry, isDrawTeam, _team, _displayName, isFlagAllowed }
};